import React from 'react';
import AbstractRequestTask from '../AbstractRequestTask';
import { setProfileLastTouch } from '../../../utils/Socialization';

class DeleteSocialRelationTask extends AbstractRequestTask {
  constructor(config, params) {
    super();
    this.config = config;
    this.params = params;
  }

  getUrl() {
    const domain = this.config.url_dominio_microfwk;

    return `${domain}services/user/deletesocialrelation`;
  }

  getParams() {
    const params = super.getParams(this.config);
    this.params = Object.assign(params, this.params);

    return params;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      const newData = super.parseErrors(data);
      return this.reject(newData, b);
    }
    if (data && data.lasttouch && data.lasttouch.profile)
      setProfileLastTouch(data.lasttouch.profile);

    this.resolve(data);
  }
}

export default DeleteSocialRelationTask;
